function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.923 24.23a1 1 0 001 1h20.154a1 1 0 001-1V10.462H3.923v13.77zm3-17.922V5.154a1.154 1.154 0 012.308 0v1.384a1.154 1.154 0 102.308 0v-.23h7.384V5.154a1.154 1.154 0 012.308 0v1.384a1.154 1.154 0 102.307 0v-.23h2.308c.637 0 1.154.517 1.154 1.154v16.692a2 2 0 01-2 2H5a2 2 0 01-2-2V7.462c0-.637.517-1.154 1.154-1.154h2.77z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.562 17.827v-1.349c0-.672-.277-1.288-.736-1.739A2.601 2.601 0 0015 14c-.718 0-1.369.289-1.826.74a2.432 2.432 0 00-.736 1.738v1.35h-.44c-.183 0-.331.135-.331.303v3.565c0 .168.148.304.33.304h6.006c.182 0 .33-.136.33-.304v-3.565c0-.168-.148-.304-.33-.304h-.44zm-3.584-2.436c.273-.248.629-.39 1.022-.391.394 0 .749.143 1.022.39.27.249.445.597.445.99v1.37h-2.934v-1.37c0-.393.175-.741.445-.99z",
  fill: "currentColor"
})));